module.exports = {"511423101":"止戈镇","511423112":"洪川镇","511423113":"余坪镇","511423114":"槽渔滩镇","511423115":"中保镇","511423116":"东岳镇","511423117":"柳江镇","511423118":"高庙镇","511423119":"瓦屋山镇","511423120":"七里坪镇","511423121":"将军镇","511423122":"中山镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/511423.json
// module id = 2483
// module chunks = 0